/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as EmbedDefs from './defs.defs'

const $nsid = 'app.bsky.embed.video'

type $nsid = typeof $nsid

export { $nsid }

type Main = {
  $type?: 'app.bsky.embed.video'

  /**
   * Alt text description of the video, for accessibility.
   */
  alt?: string

  /**
   * The mp4 video file. May be up to 100mb, formerly limited to 50mb.
   */
  video: l.BlobRef
  captions?: Caption[]
  aspectRatio?: EmbedDefs.AspectRatio

  /**
   * A hint to the client about how to present the video.
   */
  presentation?: 'default' | 'gif' | l.UnknownString
}

export type { Main }

const main = /*#__PURE__*/ l.typedObject<Main>(
  $nsid,
  'main',
  /*#__PURE__*/ l.object({
    alt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    ),
    video: /*#__PURE__*/ l.blob({ accept: ['video/mp4'], maxSize: 100000000 }),
    captions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<Caption>((() => caption) as any),
        { maxLength: 20 },
      ),
    ),
    aspectRatio: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<EmbedDefs.AspectRatio>(
        (() => EmbedDefs.aspectRatio) as any,
      ),
    ),
    presentation: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['default', 'gif'] }>(),
    ),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type View = {
  $type?: 'app.bsky.embed.video#view'
  alt?: string
  cid: l.CidString
  playlist: l.UriString
  thumbnail?: l.UriString
  aspectRatio?: EmbedDefs.AspectRatio

  /**
   * A hint to the client about how to present the video.
   */
  presentation?: 'default' | 'gif' | l.UnknownString
}

export type { View }

const view = /*#__PURE__*/ l.typedObject<View>(
  $nsid,
  'view',
  /*#__PURE__*/ l.object({
    alt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxLength: 10000, maxGraphemes: 1000 }),
    ),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    playlist: /*#__PURE__*/ l.string({ format: 'uri' }),
    thumbnail: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'uri' }),
    ),
    aspectRatio: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<EmbedDefs.AspectRatio>(
        (() => EmbedDefs.aspectRatio) as any,
      ),
    ),
    presentation: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['default', 'gif'] }>(),
    ),
  }),
)

export { view }

type Caption = {
  $type?: 'app.bsky.embed.video#caption'
  file: l.BlobRef
  lang: l.LanguageString
}

export type { Caption }

const caption = /*#__PURE__*/ l.typedObject<Caption>(
  $nsid,
  'caption',
  /*#__PURE__*/ l.object({
    file: /*#__PURE__*/ l.blob({ accept: ['text/vtt'], maxSize: 20000 }),
    lang: /*#__PURE__*/ l.string({ format: 'language' }),
  }),
)

export { caption }
